interface Props extends React.SVGAttributes<SVGElement> {}

export function Civic(props: Props) {
  return (
    <svg {...props} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.125 1.875H4.875C3.21549 1.875 1.8768 3.21815 1.8768 4.875V7.125C1.8768 8.78185 3.21549 10.125 4.875 10.125H7.125C8.65731 10.125 9.94017 8.97987 10.125 7.5H11.25C11.0602 9.60244 9.28022 11.25 7.125 11.25H4.875C2.59317 11.25 0.75 9.40317 0.75 7.125V4.875C0.75 2.59683 2.59317 0.75 4.875 0.75H7.125C9.28022 0.75 11.0602 2.39756 11.25 4.5H10.125C9.94017 3.02013 8.65731 1.875 7.125 1.875Z" />
      <path d="M7.13523 5.25C7.13523 5.62796 6.94854 5.96239 6.6622 6.16639L6.9375 7.875H5.0625L5.35464 6.16639C5.06831 5.96239 4.875 5.62796 4.875 5.25C4.875 4.62868 5.37768 4.125 6 4.125C6.62232 4.125 7.13523 4.62868 7.13523 5.25Z" />
    </svg>
  );
}
